// ======================================================================
// File: src/modules/ppe/transport/components/payment/PaymentDrawer.jsx
// Module: PPE → Transport
// Purpose:
//   Drawer for recording Transport Vehicle Payments
// ======================================================================

import React, { useState } from "react";
import transportService from "../../services/transportService";


// ======================================================================
// COMPONENT
// ======================================================================

export default function PaymentDrawer({
  vehicles = [],
  onClose,
  onSaved,
}) {

  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    transport_vehicle_id: "",
    payment_type: "ADVANCE",
    amount: "",
    payment_mode: "CASH",
    reference_no: "",
    remarks: "",
  });

  // ------------------------------------------------------------------
  // HANDLE CHANGE
  // ------------------------------------------------------------------
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ------------------------------------------------------------------
  // SAVE PAYMENT
  // ------------------------------------------------------------------
  const handleSave = async () => {
    try {
      if (!form.transport_vehicle_id) {
        alert("Please select vehicle");
        return;
      }

      setSaving(true);

      await transportService.addPayment(form);

      if (onSaved) onSaved();

    } catch (err) {
      console.error(err);
      alert("Failed to save payment");
    } finally {
      setSaving(false);
    }
  };

  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <div className="drawer-overlay">
      <div className="drawer-panel">

        {/* ============================================================
            HEADER
        ============================================================ */}
        <div className="drawer-header">
          <h5>Add Payment</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        {/* ============================================================
            BODY
        ============================================================ */}
        <div className="drawer-body">

          {/* Vehicle Selection */}
          <div className="mb-3">
            <label>Vehicle</label>
            <select
              name="transport_vehicle_id"
              className="form-control"
              value={form.transport_vehicle_id}
              onChange={handleChange}
            >
              <option value="">Select Vehicle</option>

              {vehicles.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.vehicle_no} — {v.driver_name}
                </option>
              ))}
            </select>
          </div>

          {/* Payment Type */}
          <div className="mb-3">
            <label>Payment Type</label>
            <select
              name="payment_type"
              className="form-control"
              value={form.payment_type}
              onChange={handleChange}
            >
              <option value="ADVANCE">Advance</option>
              <option value="FINAL">Final</option>
              <option value="ADJUSTMENT">Adjustment</option>
            </select>
          </div>

          {/* Amount */}
          <div className="mb-3">
            <label>Amount</label>
            <input
              type="number"
              name="amount"
              className="form-control"
              value={form.amount}
              onChange={handleChange}
            />
          </div>

          {/* Payment Mode */}
          <div className="mb-3">
            <label>Payment Mode</label>
            <select
              name="payment_mode"
              className="form-control"
              value={form.payment_mode}
              onChange={handleChange}
            >
              <option value="CASH">Cash</option>
              <option value="BANK">Bank</option>
              <option value="UPI">UPI</option>
            </select>
          </div>

          {/* Reference */}
          <div className="mb-3">
            <label>Reference No</label>
            <input
              name="reference_no"
              className="form-control"
              value={form.reference_no}
              onChange={handleChange}
            />
          </div>

          {/* Remarks */}
          <div className="mb-3">
            <label>Remarks</label>
            <textarea
              name="remarks"
              className="form-control"
              rows="3"
              value={form.remarks}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* ============================================================
            FOOTER
        ============================================================ */}
        <div className="drawer-footer">
          <button
            className="btn btn-secondary me-2"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Payment"}
          </button>
        </div>

      </div>
    </div>
  );
}
